<template>
  <section v-if="orderSummaryTotal">
    <div class="row pb-2">
      <div class="col">
        <h4>{{ $t('message.my_reservations.summary_total.title') }}</h4>
      </div>
    </div>
    <div class="row pb-1">
      <div class="col-9">{{ $t('message.my_reservations.summary_total.subtotal') }}</div>
      <div class="col-3 text-right">{{ orderSummaryTotal.subtotal | currency }}</div>
    </div>
    <div class="row pb-1" v-if="order.extra">
      <div class="col-9 ">{{ order.extra | multiLangName }}</div>
      <div class="col-3 text-right">
        {{ orderSummaryTotal.extra_cost | currency }}
      </div>
    </div>
    <div class="row pb-1"
         v-if="orderSummaryTotal.promo_code_usage && orderSummaryTotal.promo_code_usage.applied">
      <div class="col-9">
        {{ $t('message.my_reservations.summary_total.discount') }}:
        {{ orderSummaryTotal.promo_code_usage.code }}
        ({{ orderSummaryTotal.promo_code_usage.discount }}%)
      </div>
      <div class="col-3 text-right -status-discount">
        -{{ orderSummaryTotal.discount_cost | currency }}
      </div>
    </div>
    <!-- New cost format (Coins discount after VAT) -->
    <section v-if="order.is_new_cost_format">
      <div class="row mt-1" v-if="orderSummaryTotal.service_vat">
        <div class="col-9">{{ $t('message.my_reservations.summary_total.service_vat') }}</div>
        <div class="col-3 text-right">{{ orderSummaryTotal.service_vat | currency }}</div>
      </div>
      <div class="row mt-1"
           v-if="orderSummaryTotal.credit_discount_cost">
        <div class="col-9">
          {{ $t('message.my_reservations.summary_total.discount_credits') }}
        </div>
        <div class="col-3 text-right -status-discount">
          -{{ orderSummaryTotal.credit_discount_cost | currency }}
        </div>
      </div>
    </section>
    <!-- Old cost format (Coins discount before VAT) -->
    <section v-else>
      <div class="row mt-1"
           v-if="orderSummaryTotal.credit_discount_cost">
        <div class="col-9">
          {{ $t('message.my_reservations.summary_total.discount_credits') }}
        </div>
        <div class="col-3 text-right -status-discount">
          -{{ orderSummaryTotal.credit_discount_cost | currency }}
        </div>
      </div>
      <div class="row mt-1" v-if="orderSummaryTotal.service_vat">
        <div class="col-9">{{ $t('message.my_reservations.summary_total.service_vat') }}</div>
        <div class="col-3 text-right">{{ orderSummaryTotal.service_vat | currency }}</div>
      </div>
    </section>

    <div class="row">
      <div class="col-12">
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-9">
        <label>{{ $t('message.my_reservations.summary_total.total') }}</label>
      </div>
      <div class="col-3 text-right">
        <label>{{ orderSummaryTotal.total | currency }}</label>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    props: ['order'],
    data () {
      return {
        orderSummaryTotal: null
      }
    },
    watch: {
      'order.order_summary_total': function (newVal, oldVal) {
        this.orderSummaryTotal = {...newVal}
      }
    },
    mounted () {
      if (this.order && this.order.order_summary_total) {
        this.orderSummaryTotal = {...this.order.order_summary_total}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/OrderSummaryTotalShort.vue